import {
    all,
    fork,
    takeEvery,
    call,
    put,
} from 'redux-saga/effects';
import { extractError } from '@/helpers/api';
import AccommodationService from '@/services/AccommodationService';
import { types, actions } from './reducer';

function* deleteAccommodation({ id, accommodationType }) {
    try {
        yield call(AccommodationService.deleteOne, id);
        yield put(actions.deleteAccommodationSucceeded(id, `${accommodationType} deleted successfully`));
    } catch (error) {
        yield put(actions.deleteAccommodationFailed(extractError(error)));
    }
}

function* watchDeleteAccommodation() {
    yield takeEvery(
        types.REQUEST_DELETE_ACCOMMODATION,
        deleteAccommodation,
    );
}

function* deleteSaga() {
    yield all([
        fork(watchDeleteAccommodation),
    ]);
}

export default deleteSaga;
